module.exports = __webpack_public_path__ + "static/media/picked_webmoney.b30fe503.svg";